export default "__VITE_ASSET__BWBjSLuG__"